import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Typography } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

import { TEXT_ANNOTATION_TYPE, getTextAnnotationTypeLabel } from 'src/data/annotation';
import { GENERATION_TOOL, getToolMaxWordsPerKeyword } from 'src/data/generationTool';
import { AnnotationListValue } from '../AnnotationListValue';
import { AnnotationPlainValue } from '../AnnotationPlainValue';
import { shouldBeDisplayedAsList, getAnnotationHint } from './utils';
import { useStyles } from './useStyles';

export const Annotation = ({
  className,
  type,
  values,
  loading,
  wideTitle,
  interactive,
  onUseEntry,
  generationTool,
}) => {
  const styles = useStyles();

  const title = getTextAnnotationTypeLabel(type);
  const displayAsList = shouldBeDisplayedAsList(type);
  const hint = getAnnotationHint(type);
  const toolMaxWordsPerKeyword = getToolMaxWordsPerKeyword(generationTool);

  const handleUseEntry = useCallback(
    (entry) => {
      onUseEntry(type, entry);
    },
    [onUseEntry, type]
  );

  return (
    <div className={cx(styles.root, className, { [styles.wideTitle]: wideTitle })}>
      <Typography className={styles.title}>{title}</Typography>
      <Typography className={styles.value}>
        {loading ? (
          <Skeleton variant="text" />
        ) : displayAsList ? (
          <AnnotationListValue
            entries={values}
            onUseClick={handleUseEntry}
            interactive={interactive}
            hint={hint}
            toolMaxWordsPerKeyword={toolMaxWordsPerKeyword}
          />
        ) : (
          <AnnotationPlainValue entries={values} />
        )}
      </Typography>
    </div>
  );
};

Annotation.propTypes = {
  className: PropTypes.string,
  type: PropTypes.oneOf(Object.values(TEXT_ANNOTATION_TYPE)).isRequired,
  values: PropTypes.arrayOf(PropTypes.oneOf([PropTypes.string, PropTypes.shape()])),
  loading: PropTypes.bool,
  wideTitle: PropTypes.bool,
  interactive: PropTypes.bool,
  onUseEntry: PropTypes.func.isRequired,
  generationTool: PropTypes.oneOf(Object.values(GENERATION_TOOL)),
};

Annotation.defaultProps = {
  className: null,
  values: null,
  loading: false,
  wideTitle: false,
  interactive: false,
  generationTool: null,
};
